import { createSlice } from "@reduxjs/toolkit";
import { AdditionOptionData, ProductVariant } from "../../../actions/types";

const initialState: { selectedOptions: AdditionOptionData[]; variant?: ProductVariant } = {
  selectedOptions: new Array<AdditionOptionData>(),
};

export const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    setSelectedOptions: (state, action: {payload: AdditionOptionData[], type: string}) => {
      state.selectedOptions = action.payload;
    },
    setSelectedVariant: (state, action: { payload: ProductVariant, type: string }) => {
      state.variant = action.payload;
    }
  },
});

export const { setSelectedOptions, setSelectedVariant } = productSlice.actions;

export const selectOptions = (state): AdditionOptionData[] => state.product.selectedOptions;
export const selectVariant = (state): ProductVariant | undefined => state.product.variant;

export default productSlice.reducer;
